import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@rocketlane/rocket-router';
import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Container, Title, Description, LinkText } from 'components/atoms/form-elements';
import { Layout } from 'components/atoms/layout';
import { BodyShort01 } from 'components/styles';
import { RoutePaths } from 'constant';
import { ReactComponent as PaperplaneSVG } from './paper-plane.svg';
const ContainerWithTopPadding = styled(Container)`
  padding-top: 200px;
`;
const PageTitle = styled(Title)`
  color: var(--black-100);
`;
const BackAction = styled.div`
  ${BodyShort01};
`;
export const SuccessPage = ({ email })=>{
    return /*#__PURE__*/ _jsx(Layout, {
        children: /*#__PURE__*/ _jsx(ContainerWithTopPadding, {
            children: /*#__PURE__*/ _jsxs(Space, {
                direction: "vertical",
                size: 16,
                children: [
                    /*#__PURE__*/ _jsx(PaperplaneSVG, {}),
                    /*#__PURE__*/ _jsxs(PageTitle, {
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "forgot_password.success"
                            }),
                            /*#__PURE__*/ _jsx("strong", {
                                children: email
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "forgot_password.success_msg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Description, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "forgot_password.success_help"
                        })
                    }),
                    /*#__PURE__*/ _jsx(BackAction, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "forgot_password.back",
                            values: {
                                a: (chunks)=>/*#__PURE__*/ _jsx(Link, {
                                        to: RoutePaths.login,
                                        children: /*#__PURE__*/ _jsx(LinkText, {
                                            children: chunks
                                        })
                                    })
                            }
                        })
                    })
                ]
            })
        })
    });
};
